import MapGoogle from "../../components/map/map-google";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import Contact from "../../components/contact/contact";
import Hero from "../../components/hero/hero";
import Gallery from "../../components/gallery/gallery";
import Services from "../../components/services/services-page";
import FloatingWhatsApp from "../../components/floating-whatsapp/floatingWhatsApp";

const Home = () => {
  return (
    <>
      <Header />

      <main>
        <Hero />
        <Services />
        <Gallery />
        <Contact />
        <MapGoogle />
      </main>

      <Footer />

      <FloatingWhatsApp />
    </>
  );
};

export default Home;
